import {content, headingContainer, image, subheading, wrapper} from "@/components/support/styles/support-hero";
import React from "react";
import scss from "@/styles/pages/support/support-hero.module.scss";
import ContentHeading from "@/components/content-heading";

const SupportHeader: React.FC = () => {
    return (

        <div className={wrapper}>
            <div className={scss["image-overlay"]}>
                <img
                    className={image}
                    srcSet={`
                        /assets/images/backgrounds/support/hero/small.webp 420w, 
                			/assets/images/backgrounds/support/hero/small.jpg 420w,
                			/assets/images/backgrounds/support/hero/medium.webp 733w, 
                			/assets/images/backgrounds/support/hero/medium.jpg 733w,
                			/assets/images/backgrounds/support/hero/large.webp 1465w,
                			/assets/images/backgrounds/support/hero/large.jpg 1465w,
					`}
                    sizes="(max-width:736px) 420px, (max-width:1280px) 800px, 1500px"
                    src={`/assets/images/backgrounds/support/hero/small.jpg`}
                    title="hearX Group support page"
                    alt="hearX Group representative ready to assist anyone who needs support with their hearX® solutions "
                />
            </div>

            {/*Page heading*/}
            <div className={headingContainer}>
                <div className={content}>
                    <ContentHeading
                        h="p"
                        className="mobile:justify-start mobile:items-start tablet:justify-start"
                        backdropPosition="mobile:left-4 tablet:left-8"
                        fontSize="mobile:text-xl tablet:text-5xl"
                        background="bg-primary bg-opacity-50"
                    >
                        Support
                    </ContentHeading>
                    <p className={subheading}>
                        Need assistance? We’re all ears.
                    </p>
                </div>
            </div>
            </div>

    )
}

export default SupportHeader
